<h3 class="mt-3">Recent Actions</h3>
<div class="table-container">
  @if (stockItems.data.length > 0) {
    <table mat-table matSort [dataSource]="stockItems">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let row"><app-table-cell-date [value]="row.date" /></td>
      </ng-container>

      <ng-container matColumnDef="stockItem.amount">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Amount</th>
        <td mat-cell *matCellDef="let row">
          {{ formatAmount(row) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="purchase.price">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Price</th>
        <td mat-cell *matCellDef="let row">
          <app-purchase-price [data]="row.purchase" />
        </td>
      </ng-container>

      <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
        <td mat-cell *matCellDef="let row">
          {{ row.type }}
        </td>
      </ng-container>

      <ng-container matColumnDef="undo">
        <th mat-header-cell *matHeaderCellDef stickyEnd></th>
        <td mat-cell *matCellDef="let row">
          <button
            mat-icon-button
            (click)="undoRecentAction(row.stockItem.id, row.type)"
            [disabled]="isSubmitting"
            [matTooltip]="'Undo ' + row.type"
            matTooltipPosition="right">
            <mat-icon>undo</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns" [ngClass]="{ undone: row.undone }"></tr>
    </table>
  }
</div>
